export default __webpack_public_path__ + "static/media/doc.6657c999.svg";